import React from 'react';
import ReactDOM from 'react-dom';
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';
import ContextualOnboarding, {
  useSuppressFlagStorage,
} from 'components/v2/contextual-onboarding';
import OrderItemOnboarding from '../common/order-item-onboarding';

const onboardingID = 'shopifyListOrderItemPrice';
const root = document.getElementById('root');

const useOrderItemOnboarding = fulfillmentOrders => {
  const { checkSuppress, setSuppress } = useSuppressFlagStorage(onboardingID);

  // memo first order with line items
  const orderWithItems = React.useMemo(
    () => {
      if (_isEmpty(fulfillmentOrders)) return;

      const orderWithItems = _find(
        fulfillmentOrders,
        x => x.ID && !_isEmpty(x.lineItems) && !x.disabled,
      );

      return orderWithItems;
    },
    [fulfillmentOrders],
  );

  const checkIfShowOrderItemOnboarding = React.useCallback(
    order => {
      if (checkSuppress()) return false;
      if (!order || !orderWithItems) return false;
      return order.ID == orderWithItems.ID;
    },
    [orderWithItems, checkSuppress],
  );

  const setOrderItemHoverOnboardingSuppress = React.useCallback(
    () => {
      setSuppress(true);
    },
    [setSuppress],
  );

  const getOrderItemOnboardingElement = React.useCallback(
    (order, elementID) =>
      checkIfShowOrderItemOnboarding(order)
        ? ReactDOM.createPortal(
            <ContextualOnboarding
              elementID={elementID}
              onboardingID={onboardingID}
              onboardingVisual={<OrderItemOnboarding />}
              onboardingVisualPlacement={'leftTop'}
              maxOnboardingTimes={1}
              delay={60000}
              triggerRules={{
                yOffset: 100,
                suppress: checkSuppress(),
              }}
            />,
            root,
          )
        : null,
    [checkIfShowOrderItemOnboarding, checkSuppress],
  );

  return {
    getOrderItemOnboardingElement,
    setOrderItemHoverOnboardingSuppress,
  };
};

export default useOrderItemOnboarding;
